import React from "react";

export default function Footer() {
    return (
        <footer>
            <div className="footer-nav">
                <p className="miaov-contact clear">
                    <a className="iconfont icon-youxiang" href="mailto:2527405093@stu.suda.edu.cn">2527405093@stu.suda.edu.cn</a>
                    <a className="iconfont icon-24gl-telephone2" href="tel:19850006358">19850006358</a>
                </p>
                {/*<nav className="clear">*/}
                {/*    <a>首页</a>*/}
                {/*    <a>课前检测</a>*/}
                {/*    <a>课堂学习</a>*/}
                {/*    <a>课后巩固</a>*/}
                {/*</nav>*/}
            </div>
            <p className="footer-copy">中国大学生计算机设计大赛微课类作品，苏州大学版权所有</p>
        </footer>
    );
}